import axios from "axios";
import store from "./../store/";
import i18n from "./../i18n";

export default function setup() {
  axios.interceptors.request.use(config => {
    store.dispatch("setLoading", true);
    return config;
  });

  axios.interceptors.response.use(
    response => {
      store.dispatch("setLoading", false);
      return response;
    },
    error => {
      store.dispatch("setLoading", false);
      const messages = error.response.data.messages;

      messages.forEach(item => {
        if (i18n.te(`msg.${item}`)) {
          store.dispatch("showErrorToast", i18n.t(`msg.${item}`));
        } else {
          store.dispatch("showErrorToast", i18n.t(`${item}`));
        }
      });
      // store.dispatch("showErrorToast", error.response.data.messages);
      return Promise.reject(error);
    }
  );
}
